import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { IssueStatus } from '@/entities/todo/constants';
import { IssuePriority, IssueType } from '@/entities/issue/constants';
import { authorizedTo, id, entityItem } from '@/services/api';
import { recordCodec as groupCodec } from '@/services/api/resources/group';
import { assignee as assigneeCodec } from '@/services/api/resources/assignee';

export const associateAssignee = t.type({
  id,
  email: t.string,
});

export const issuePhoto = t.type({
  image_id: t.union([t.string, t.null, t.undefined]),
  height: t.union([t.number, t.undefined]),
  width: t.union([t.number, t.undefined]),
  uuid: t.union([t.string, t.null, t.undefined]),
  drawing_id: t.union([t.string, t.null, t.undefined]),
});

export const issueBreadcrumb = t.type({
  type: t.string,
  title: t.union([t.string, t.null, t.undefined]),
  response: t.union([t.array(t.string), t.array(t.boolean), t.null, t.undefined, t.any]),
  parent: t.union([t.undefined, t.type({
    type: t.union([t.string, t.null, t.undefined]),
    title: t.union([t.string, t.null, t.undefined]),
    response: t.union([t.array(t.string), t.array(t.boolean), t.null, t.undefined, t.any]),
  })]),
});

export const issuePayload = t.type({
  type: t.string,
  breadcrumb: t.union([t.array(issueBreadcrumb), t.undefined]),
  inspection_id: t.union([t.number, t.undefined, t.null]),
  sensor_id: t.union([t.number, t.undefined]),
  sensor_title: t.union([t.string, t.undefined]),
  metric: t.union([t.string, t.undefined]),
  value: t.union([t.number, t.undefined]),
  timestamp: t.union([t.number, t.undefined]),
});

export const data = t.type({
  title: t.string,
  description: t.union([t.string, t.null]),
  assignees: t.array(assigneeCodec),
  associateAssignees: t.array(associateAssignee),
  status: t.union([
    t.literal(IssueStatus.Pending),
    t.literal(IssueStatus.InProgress),
    t.literal(IssueStatus.Done),
    t.literal(IssueStatus.CantDo),
  ]),
  entityItem: t.union([entityItem, t.null]),
  priority: t.union([
    //remove Low here when we sure that it is no more in DB
    t.literal(IssuePriority.Low),
    t.literal(IssuePriority.Normal),
    t.literal(IssuePriority.High),
  ]),
  suggestedCorrectiveAction: t.union([t.string, t.null]),
  performedCorrectiveAction: t.union([t.string, t.null]),
  deadline: t.union([DateFromUnixTime, t.null]),
  photos: t.array(issuePhoto),
  assignedGroups: t.array(groupCodec),
  type: t.union([
    t.literal(IssueType.Automatic),
    t.literal(IssueType.InForm),
    t.literal(IssueType.Sensor),
    t.literal(IssueType.AdHoc),
    t.literal(IssueType.ManualForm),
    t.literal(IssueType.AutomaticForm),
    t.null,
  ]),
  user: t.union([assigneeCodec, t.null]),
  inspection_id: t.union([t.number, t.null]),
  payload: t.union([issuePayload, t.null]),
  inspection: t.union([
    t.type({ title: t.string, id: t.number }),
    t.null,
  ]),
  inspectionTitle: t.union([t.string, t.undefined, t.null]),
  approvers: t.union([t.array(assigneeCodec), t.null]),
  approversEnabled: t.union([t.boolean, t.undefined]),
  approvalEntitySpecificAssignments: t.union([t.boolean, t.undefined]), //TODO: fix undefined
  approval: t.union([t.type({
    id: t.number,
    status: t.string,
  }), t.null]),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const unPaginatedRecord = t.type({
  data: t.array(recordCodec),
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  description: t.union([t.string, t.null]),
  assignees: t.array(t.union([t.number, t.string])),
  associateAssignees: t.array(t.union([t.number, t.string])),
  status: t.number,
  entityItem: t.union([t.number, t.null]),
  priority: t.union([
    //remove Low here when we sure that it is no more in DB
    t.literal(IssuePriority.Low),
    t.literal(IssuePriority.Normal),
    t.literal(IssuePriority.High),
  ]),
  question: t.union([t.number, t.null]),
  type: t.union([
    t.literal(IssueType.InForm),
    t.literal(IssueType.AdHoc),
    t.literal(IssueType.Sensor),
    t.literal(IssueType.Automatic),
    t.literal(IssueType.ManualForm),
    t.literal(IssueType.AutomaticForm),
    t.null,
  ]),
  suggestedCorrectiveAction: t.union([t.string, t.null]),
  performedCorrectiveAction: t.union([t.string, t.null]),
  deadline: t.union([t.number, t.null]),
  photos: t.array(issuePhoto),
});

export const formSendCodec = t.type({
  ...formCodec.props,
  ...{ timezone: t.union([t.string, t.null]) },
});
